import { makeAutoObservable, runInAction } from 'mobx';
import { makePersistable } from 'mobx-persist-store';
export default class TransactionStore {
	constructor() {
		makeAutoObservable(this);
		makePersistable(this, {
			name: 'TransactionStore',
			properties: [
				'transactions',
				'transactionTotalCount',
				'summary',
				'transactionsAnalysis',
				'chargeAnalysis',
			],
		});
	}

	transactions = [];
	transactionTotalCount = [];
	summary = [];
	transactionsAnalysis = [];
	chargeAnalysis = [];

	reset = () => {
		this.transactions = [];	
		this.transactionTotalCount = [];
		this.summary = {};
		this.transactionsAnalysis = [];
		this.chargeAnalysis = [];
	};
	 
	setTransactions = async transactions => {
		runInAction(async () => {
			this.transactions = transactions;
		});
	}; 

	setTransactionTotalCount = async transactionTotalCount => {
		runInAction(async () => {
			this.transactionTotalCount = transactionTotalCount;
		});
	}; 

	setSummary = async summary => {
		runInAction(async () => {
			this.summary = summary;
		});
	}; 

	setTransactionsAnalysis = async state => {
		runInAction(async () => {
			this.transactionsAnalysis = state;
		});
	}; 
	setChargeAnalysis = async state => {
		runInAction(async () => {
			this.chargeAnalysis = state;
		});
	}; 
}
